import script from "./Sprachtechnik-Customers.vue?vue&type=script&setup=true&lang=js"
export * from "./Sprachtechnik-Customers.vue?vue&type=script&setup=true&lang=js"

import "./Sprachtechnik-Customers.vue?vue&type=style&index=0&id=189f3f0a&lang=css"
import "./Sprachtechnik-Customers.vue?vue&type=style&index=1&id=189f3f0a&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-189f3f0a"]])

export default __exports__